import styled from '@emotion/styled';
import { brandNeutralColors, colors } from '@anyroad/theme';

export const DiscountContainer = styled.div`
  position: relative;
  padding: 28px 0 24px;
  background: ${brandNeutralColors.white};
  border-left: none;
  border-right: none;
  border-radius: 0;
  margin: 24px 0;
  box-shadow: none;
  border-top: 1px solid ${brandNeutralColors.borderAction};
  border-bottom: 1px solid ${brandNeutralColors.borderAction};

  @media (max-width: 767px) {
    padding: 15px 0;
  }

  &.expanded {
    padding-bottom: 30px;
  }
`;

export const DiscountHeader = styled.div`
  max-height: 76px;
  display: inline-block;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 0;

  &.expanded {
    margin-bottom: 24px;
  }
`;

export const DiscountIcon = styled.div<{ isExpanded: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: ${brandNeutralColors.text.icon};
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
`;

export const IconLine = styled.div<{ isExpanded: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 2px;
    background: white;
    border-radius: 1px;
    transition:
      transform 0.2s ease,
      opacity 0.2s ease;
  }

  &::before {
    transform: rotate(0deg);
  }

  &::after {
    transform: ${(props) =>
      props.isExpanded ? 'rotate(0deg) scaleX(0)' : 'rotate(90deg) scaleX(1)'};
  }
`;

export const DiscountTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: ${brandNeutralColors.text.secondary};
  display: inline-block;
  text-transform: capitalize;
`;

export const InputButtonWrapper = styled.div`
  display: none;
  flex-wrap: nowrap;
  margin-bottom: 0 !important;

  .ui.button {
    background: transparent;
    flex: 1;
    color: ${brandNeutralColors.text.secondary};
    padding: 16px 20px;
    vertical-align: top;
    font-family: inherit;
    border: 1px solid ${brandNeutralColors.borderAction};
  }

  &.row > .input {
    flex: 3;
    margin-right: 16px;
  }

  &.expanded {
    display: flex;
  }
`;

export const DiscountInput = styled.input<{ hasError?: boolean }>`
  flex: 3;
  padding: 16px 20px;
  border: 1px solid
    ${(props) =>
      props.hasError ? colors.error : brandNeutralColors.borderAction};
  border-radius: 0;
  font-size: 14px;
  transition: border-color 0.2s ease;
  margin-right: 16px;
  margin-bottom: 0;

  &:focus {
    outline: none;
    border-color: ${(props) =>
      props.hasError ? colors.error : brandNeutralColors.borderAction};
  }

  &::placeholder {
    color: ${brandNeutralColors.text.placeholder};
  }
`;

export const ApplyButton = styled.button<{ isLoading: boolean }>`
  background: transparent;
  flex: 1;
  color: ${brandNeutralColors.text.secondary};
  padding: 16px 20px;
  vertical-align: top;
  font-family: inherit;
  border: 1px solid ${brandNeutralColors.borderAction};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${(props) => (props.isLoading ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #f8f9fa;
  }
`;

export const CodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
`;

export const SuccessIcon = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background: ${brandNeutralColors.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: white;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
  position: relative;

  &.icon {
    line-height: 1;
    font-size: 12px;
  }

  &.af-checkmark {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const AppliedContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AppliedText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${brandNeutralColors.text.primary};
  margin-right: auto;
  flex: 1;
`;

export const AppliedCode = styled.div`
  font-size: 16px;
  color: ${brandNeutralColors.text.primary};
  font-weight: bold;
  background: none;
  padding: 0;
  border-radius: 0;
  display: inline;
  margin-right: 8px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: ${colors.error};
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  margin: 0;
  display: inline;

  &:hover {
    color: ${colors.error};
  }
`;

export const ErrorMessage = styled.div`
  color: white;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 0;
  padding: 8px 12px;
  background: ${colors.error};
  border: none;
  border-radius: 0;
  text-align: center;
`;
